@if (!isLoading) {
  @if (showRequisitions) {
    @for (
      group of requisitionsGroups;
      track trackByIndex(groupIndex, group);
      let groupIndex = $index;
      let groupCount = $count;
      let firstGroup = $first
    ) {
      @if (showGroups) {
        <rt-offers-page-group-heading
          [name]="group.name!"
          [counter]="group.count || 0"
          [state]="collapsedGroups.includes(group.name!) ? 'collapsed' : 'normal'"
          (click)="changeGroupVisibility(group.name!)"
          [attr.margin-top-small]="!firstGroup || null"
        />
      }
      <div [@collapse]="collapsedGroups.includes(group.name!) ? 'collapsed' : 'normal'">
        @for (
          requisition of group.requisitions;
          track trackById(index, requisition);
          let last = $last;
          let index = $index
        ) {
          <rt-intersection-observer-entry
            [template]="template"
            [firstPaintOnly]="true"
            [templateContext]="requisition"
            [forceVisible]="(groupIndex + 1) * index < 8"
          />
        }

        <ng-template #template let-requisition margin-bottom>
          <rt-requisitions-list-tile
            [requisition]="requisition"
            [canEditRequisitions]="canEditRequisitions"
            [canAddJobs]="canCreateJobs"
            [jobsMap]="jobsMap"
            [isArchived]="!!requisition.archivedAt"
            (follow)="follow($event)"
            (unfollow)="unfollow($event)"
            (duplicate)="duplicate($event)"
            (archive)="archive($event)"
            (retrieve)="retrieve($event)"
            (delete)="delete($event)"
            (cancelRequest)="cancelRequest($event)"
            (openRequisition)="openRequisition($event)"
            (showJobsList)="showJobsListDialog($event)"
            (addJob)="createJob($event)"
            margin-bottom
          />
        </ng-template>
      </div>
    }
  } @else {
    <rt-requisitions-list-empty-state-container [params]="params" />
  }
} @else {
  <div [style.margin]="'0 auto'" [style.maxWidth]="'1000px'">
    @for (placeholders of placeholders; track trackByIndex($index, placeholders)) {
      <rt-box-placeloader [height]="140" margin-bottom-small />
    }
  </div>
}
